import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

export type GetLineItemQuantityValidatedByMerchantParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * A Line item can be split into different parts in the context of a return request.
 * This function returns the quantity of the line item that has been validated by the merchant.
 *
 * For example, the order contains 3 white t-shirt
 *
 * ***********************************
 * White t-shirt                   x3
 * ***********************************
 *
 * The customer returns 3 white t-shirt.
 * The logistician has validated 1 white t-shirt.
 * The merchant has validated 1 white t-shirt.
 * The merchant has rejected 1 white t-shirt.
 *
 * This function would return 1 (item validated by merchant)
 */
export function getLineItemValidatedByMerchantQuantity({
  lineItem,
}: GetLineItemQuantityValidatedByMerchantParams) {
  return lineItem.merchant_informations.reduce((acc, merchantInformation) => {
    if (merchantInformation.status === "ok") {
      return acc + merchantInformation.quantity;
    }
    return acc;
  }, 0);
}
